import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/landing/landing.component').then(m => m.LandingComponent),
  },
  {
    path: 'scoreboard',
    loadComponent: () =>
      import('./pages/scoreboard-config/scoreboard-config.component').then(m => m.ScoreboardConfigComponent),
  },
  {
    path: 'scoreboard/display',
    loadComponent: () =>
      import('./pages/scoreboard-display/scoreboard-display.component').then(m => m.ScoreboardDisplayComponent),
  },
  {
    path: 'obs',
    loadComponent: () =>
      import('./pages/obs-config/obs-config.component').then(m => m.ObsConfigComponent),
  },
  {
    path: 'obs/display',
    loadComponent: () =>
      import('./pages/obs-display/obs-display.component').then(m => m.ObsDisplayComponent),
  },
  { path: '**', redirectTo: '' },
];
